import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
export type LatestQuestionFragment = {
  __typename?: 'Message'
  id: number
  type: Types.MessageType
  appointmentAt?: any | null
  approvedAt?: any | null
  letterRequest?: {
    __typename?: 'LetterRequest'
    id: number
    powerOfAttorney?: { __typename?: 'PowerOfAttorney'; uid: string } | null
  } | null
  topic: { __typename?: 'Topic'; id: number; name: string }
}

export const LatestQuestionFragmentDoc = gql`
  fragment LatestQuestion on Message {
    id
    type
    appointmentAt
    approvedAt
    letterRequest {
      id
      powerOfAttorney {
        uid
      }
    }
    topic {
      id
      name
    }
  }
`
